// eslint-disable-next-line import/prefer-default-export
export const createAsyncActions = (type) => ({
  INIT: `${type}`,
  FAIL: `${type}_FAIL`,
  SUCCESS: `${type}_SUCCESS`,
});  